package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2024_03_01_Day_1
import com.veldekar.components.logs.Log_2024_03_01_Day_2
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2024-03-01")
@Composable
public fun Log_2024_03_01(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "The Siege of Cark",
        ogTitle = "The Siege of Cark",
        date = LocalDate(2_024, 3, 1),
        ogDescription = "The heroes call in the Malusian army to break a siege of giants and orcs at the town of Cark.",
        ogImage = "ai/2024-03-01.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-45", dateString = "Newgrowth 45")
        Log_2024_03_01_Day_1()
        SessionDayHeader(dayId = "newgrowth-46", dateString = "Newgrowth 46")
        Log_2024_03_01_Day_2()
    }
}
